const videos = document.querySelectorAll('.hover-play-video');
const videoContainers = document.querySelectorAll('.video-container');

videoContainers.forEach(videoContainer => {
  videoContainer.addEventListener('mousemove', () => {
    const video = videoContainer.querySelector('.hover-play-video');
    if (!video.paused) {
      return; // Prevent unnecessary play calls if already playing
    }
    const playButton = videoContainer.querySelector('.play-button');
    playButton.classList.add("hidden");
    video.play();
  });

  videoContainer.addEventListener('mouseleave', () => {
    const video = videoContainer.querySelector('.hover-play-video');
    const playButton = videoContainer.querySelector('.play-button');
    playButton.classList.remove("hidden");
    video.pause();
  });
});